export default __webpack_public_path__ + "static/Rhyme2-72de3cf53b1059ed50264cf2e2088751.mp3";